import React from "react";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Text,
} from "@chakra-ui/react";

/**
 * Renders an FAQ accordion from a `[{ q, a }]` array.
 *
 * The same array is handed to `<Seo faqs={...} />` on each page, so the
 * FAQPage JSON-LD can never drift from the questions a visitor actually sees.
 *
 * Answers render inside an always-present <AccordionPanel>; Chakra collapses
 * them visually but leaves the text in the DOM, so crawlers and AI answer
 * engines still read them.
 */
const FaqSection = ({ items, heading = "Frequently Asked Questions" }) => {
  if (!items || !items.length) return null;

  return (
    <Box mt={6} as="section" aria-labelledby="faq-heading">
      <Heading
        as="h2"
        id="faq-heading"
        fontSize={{ base: "lg", md: "xl" }}
        fontWeight="bold"
        mt={4}
      >
        {heading}
      </Heading>
      <Accordion allowToggle mt={4}>
        {items.map((item) => (
          <AccordionItem
            key={item.q}
            bg="white"
            borderWidth="1px"
            borderRadius="md"
            boxShadow="sm"
            mb={4}
          >
            <Heading as="h3" fontSize="md" fontWeight="semibold">
              <AccordionButton>
                <Box flex="1" textAlign="left">
                  {item.q}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </Heading>
            <AccordionPanel pb={4}>
              <Text fontWeight="light">{item.a}</Text>
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Box>
  );
};

export default FaqSection;
